<style lang="less" scoped>
@import "../assets/css/common.less";
.searchData {
  padding-top: 45px;
}
</style>
<template>
  <div>
    <Header ref="header"></Header>
    <div class="content">
      <div class="main">
        <div class="header">
          <div class="search">
            <Input
              type="text"
              :placeholder="$t('main.home1')"
              v-model="container"
              search
              @keyup.enter.native="search"
              @on-search="search"
            />
          </div>
        </div>

        <div class="lists">
          <div class="searchData">
            <van-list
              v-if="datas.length > 0"
              class="van-list"
              v-model="loading"
              :finished="finished"
              finished-text=""
              @load="getList"
            >
              <van-cell
                class="datas"
                v-for="(item, index) in datas"
                :key="index"
              >
                <h4 class="title" style="display: flex">
                  <a @click="handleDetail(item)">
                    <span v-if="lang != 'en' || !item.title2">{{
                      item.title1
                    }}</span>
                    <span v-if="lang == 'en'">{{ item.title2 }}</span></a
                  >
                </h4>

                <p class="parse">
                  <span v-if="item.publish_date" class="date"
                    >{{ $t("search.search1") }}：{{
                      item.publish_date.substring(0, 10)
                    }}</span
                  >
                </p>
                <p class="parse">
                  <span v-if="item.publisher_name"
                    >{{ $t("search.search2") }}：{{ item.publisher_name }}</span
                  >
                </p>

                <p class="identify">
                  <a
                    class="date links"
                    :href="'https://cstr.cn/' + $checkPrefix(item.identifier)"
                    target="_blank"
                  >
                    <img class="link" src="@/assets/images/nav.png" />CSTR:{{
                      item.identifier
                    }}
                  </a>
                </p>
              </van-cell>
            </van-list>
            <noData v-else></noData>
          </div>
          <back-top></back-top>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import backTop from "./backTop.vue";
import { Loadmore } from "mint-ui";
import Header from "./comHeader.vue";
import noData from "./nodata.vue";
import { Indicator } from "mint-ui";
export default {
  inject: ["reload"],
  components: {
    backTop,
    noData,
    Header,
    [Loadmore.name]: Loadmore,
    [Indicator.name]: Indicator,
  },
  data() {
    return {
      pageNumber: 1,
      topStatus: "",
      pageSize: 10,
      list: [],
      total: 10,
      finished: false,
      datas: [],
      lang: "",
      type: "",
      title: "",
      container: "all",
      yearName: "",
      resourceName: "",
      prefix: "",
      resource_type: [],
      url: "",
      config_list: [],
      resource_types: [],
      title: "",
    };
  },
  created() {},
  mounted() {
    Indicator.open({
      text: "loading...",
      spinnerType: "fading-circle",
    });
    this.lang = this.$cookie.get("lang");
    // this.$refs.header.title = this.title;
    this.config_list = require("../assets/data/type.json").lists;
    if (this.config_list) {
      this.config_list.forEach((item) => {
        if (item.value == this.$route.query.params) {
          if (this.lang == "en") {
            this.$refs.header.title = item.nameEn;
          } else {
            this.$refs.header.title = item.name;
          }

          this.resource_types = item.resource_types;
        }
      });
    }
    if (this.$route.query.value) {
      this.container = this.$route.query.value;
      this.resource_types = ["11"];
      this.getList();
    } else {
      this.getList();
    }
  },
  methods: {
    getList() {
      var parameter = {
        page_num: this.pageNumber,
        page_size: this.pageSize,
        query: this.container,
        resource_type: this.resource_types,
        publisher_name: [],
        identifier: null,
        prefix: "",
        registrant: null,
      };
      this.$api.getSpeciesData(parameter).then((res) => {
        if (res.status == 200) {
          Indicator.close();
          const results = res.data.items;
          this.pageNumber++;
          this.loading = false;
          this.datas = this.datas.concat(results);
          if (results.length === 0) {
            this.finished = true;
          }
        }
      });
    },
    search() {
      this.datas = [];
      Indicator.open({
        text: "loading...",
        spinnerType: "fading-circle",
      });
      this.pageNumber = 1;
      this.getList();
    },
    handleDetail(item) {
      var link = "/detail?identifier=" + item.identifier;
      window.open(link, "_blank");
    },
    cancel() {
      Indicator.open({
        text: "loading...",
        spinnerType: "fading-circle",
      });
      this.container = "";
      this.datas = [];
      this.pageNumber = 1;
      this.getList();
    },
  },
};
</script>